import { PleaseWait } from "./pleaseWait";
export class FormUtils {
    static getForm(formElement) {
        const closestForm = formElement ? $(formElement).closest('form')[0] : null;
        return closestForm || $('form')[0] || null;
    }
    static ensureHiddenExists(form, elementId) {
        let hiddenElement = form.querySelector(`#${elementId}`);
        if (!hiddenElement) {
            hiddenElement = document.createElement('input');
            hiddenElement.type = 'hidden';
            hiddenElement.id = elementId;
            hiddenElement.name = elementId;
            form.appendChild(hiddenElement);
        }
        return hiddenElement;
    }
    static submitForm(formElement, action, target) {
        const form = FormUtils.getForm(formElement);
        if (!form) {
            console.error('Form not found!');
            return;
        }
        const originalTarget = form.target;
        const originalAction = form.action;
        if (action)
            form.action = action;
        if (target)
            form.target = target;
        form.submit();
        form.action = originalAction;
        form.target = originalTarget;
    }
    static exportForm(formElement, action, format, additionalProperties) {
        let form = FormUtils.getForm(formElement);
        if (!form) {
            form = document.createElement('form');
            form.method = 'post';
            form.action = action;
            document.body.appendChild(form);
        }
        const tokenElement = FormUtils.ensureHiddenExists(form, 'downloadToken');
        const token = new Date().getTime().toString();
        tokenElement.value = token;
        FormUtils.blockUIForDownload(token);
        const formatElement = FormUtils.ensureHiddenExists(form, 'format');
        formatElement.value = format;
        if (additionalProperties) {
            additionalProperties.forEach((item) => {
                if (item && item.key && item.value !== undefined) {
                    const value = Array.isArray(item.value) || typeof item.value === 'object'
                        ? JSON.stringify(item.value)
                        : item.value;
                    const itemElement = FormUtils.ensureHiddenExists(form, item.key);
                    itemElement.value = value;
                }
            });
        }
        if (!formElement) {
            formElement = tokenElement;
        }
        FormUtils.submitForm(formElement, action);
    }
    static blockUIForDownload(token) {
        PleaseWait.show();
        const fileDownloadCheckTimer = window.setInterval(() => {
            const cookieValue = window.Cookies.get('downloadToken');
            if (cookieValue === token) {
                window.clearInterval(fileDownloadCheckTimer);
                window.Cookies.remove('downloadToken');
                PleaseWait.hide();
            }
        }, 500);
    }
    static reattachValidations(form) {
        if (!form || form.length == 0)
            return;
        form.removeData("validator");
        form.removeData("unobtrusiveValidation");
        $.validator.unobtrusive.parse(form);
    }
}
window.FormUtils = FormUtils;
window.getForm = FormUtils.getForm;
window.submitForm = FormUtils.submitForm;
window.exportForm = FormUtils.exportForm;
window.blockUIForDownload = FormUtils.blockUIForDownload;
